import * as React from "react";
import { Apps } from "./apps.mjs";
import { Channels } from "./channels.mjs";
import { ServiceGroups } from "./service-groups.mjs";
import { ThemePackets } from "./theme-packets.mjs";
const TvComparisonContext = React.createContext({
  soundLabel: "",
  subTitlesLabel: "",
  scrollLeftButton: { text: "Left" },
  scrollRightButton: { text: "Right" },
  onDetailsInfoToggle: void 0
});
const TvComparison = (props) => {
  const { soundLabel, subTitlesLabel, scrollLeftButton, scrollRightButton, onDetailsInfoToggle, packets, sections, initialHeadingLevel = 2 } = props;
  const tvComparisonContextValue = React.useMemo(
    () => ({
      soundLabel,
      subTitlesLabel,
      scrollLeftButton,
      scrollRightButton,
      onDetailsInfoToggle
    }),
    [soundLabel, subTitlesLabel, scrollLeftButton, scrollRightButton, onDetailsInfoToggle]
  );
  const renderSection = (section, index) => {
    var _a;
    const isFirstTable = index === 0;
    switch (section.type) {
      case "serviceGroups": {
        const { data: serviceGroups } = section;
        const viewerSlots = (_a = sections.find((s) => s.type === "viewerSlots")) == null ? void 0 : _a.data;
        const hasServicesOrSlots = serviceGroups.services.length > 0 || viewerSlots.slots.length > 0;
        return hasServicesOrSlots ? /* @__PURE__ */ React.createElement(
          ServiceGroups,
          {
            key: "serviceGroups-section",
            packets,
            isFirstTable,
            serviceGroups,
            initialHeadingLevel,
            viewerSlots
          }
        ) : void 0;
      }
      case "themePackets": {
        const { data: themePackets } = section;
        return themePackets.packets.length > 0 ? /* @__PURE__ */ React.createElement(
          ThemePackets,
          {
            key: "themePackets-section",
            isFirstTable,
            packets,
            themePackets,
            initialHeadingLevel
          }
        ) : void 0;
      }
      case "channels": {
        const { data: channelsData } = section;
        return channelsData.channels.length > 0 ? /* @__PURE__ */ React.createElement(
          Channels,
          {
            key: "channels-section",
            packets,
            isFirstTable,
            channelsData,
            initialHeadingLevel
          }
        ) : void 0;
      }
      case "apps": {
        const { data: appsData } = section;
        return appsData.apps.length > 0 ? /* @__PURE__ */ React.createElement(Apps, { key: "apps-section", packets, isFirstTable, appsData, initialHeadingLevel }) : void 0;
      }
    }
  };
  return /* @__PURE__ */ React.createElement(TvComparisonContext.Provider, { value: tvComparisonContextValue }, /* @__PURE__ */ React.createElement("div", { className: "tv-comparison" }, sections.map(renderSection)));
};
export {
  TvComparison,
  TvComparisonContext
};
